import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetUrl } from "../config/GetUrl";

export const bannerApi = createApi({
  reducerPath: "bannerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: GetUrl.API_URL,
  }),
  endpoints: (builder) => ({
    CreateBannerPost: builder.mutation({
      query: (data) => ({
        url: "/api/v1/Admin/addBanner",
        method: "POST",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetBannerList: builder.query({
      query: () => ({
        url: "/api/v1/Admin/getAllBanner",
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetSingleCharity: builder.query({
      query: (id) => ({
        url: `/api/v1/Admin/getBannerById/${id}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    EditBanner: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/v1/Admin/updateBanner/${id}`,
        method: "PUT",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    DeleteBanner: builder.mutation({
      query: (id) => ({
        url: `/api/v1/Admin/deleteBanner/${id}`,
        method: "DELETE",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    CreateRetailerBanner: builder.mutation({
      query: (data) => ({
        url: "/admin/create-reatiler-banner",
        method: "POST",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetRetailerBanner: builder.query({
      query: () => ({
        url: "/admin/get-retailer-banner",
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetRetailerBannerDetail: builder.query({
      query: (id) => ({
        url: `/admin/get-retailer-banner-detail/${id}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    EditRetailerBanner: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/edit-retailer-banner/${id}`,
        method: "PUT",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    DeleteRetailerBanner: builder.mutation({
      query: (id) => ({
        url: `/admin/delete-retailer-banner/${id}`,
        method: "DELETE",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateBannerPostMutation,
  useGetBannerListQuery,
  useGetSingleCharityQuery,
  useEditBannerMutation,
  useDeleteBannerMutation,
  useCreateRetailerBannerMutation,
  useGetRetailerBannerQuery,
  useGetRetailerBannerDetailQuery,
  useEditRetailerBannerMutation,
  useDeleteRetailerBannerMutation
} = bannerApi;
